import { isCSR } from '../domain';
export const isInLivePreviewIframe = () => isCSR() && window.location !== window.parent.location;
//# sourceMappingURL=isInLivePreviewIframe.js.map